import { SET_TOAST } from 'redux/reducers/toast';

export function setToast(payload) {
    return {
        type: SET_TOAST,
        payload,
    };
}
